<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <div v-if="!isEmpresa">
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2>{{ $t('agenda.domiciliation_date_filter') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.from')}}</label>
                      <el-form-item prop="domiciliationFrom">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.domiciliationFrom.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.to')}}</label>
                      <el-form-item prop="domiciliationTo">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.domiciliationTo.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div class="flex-1">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.nombre_cuenta') }}</label>
                <el-form-item prop="BankAccountAlias">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.BankAccountAlias.value"
                    maxlength="60"
                  />
                </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.iban') }}</label>
              <el-form-item prop="IBANAccountNumber">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.IBANAccountNumber.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div v-if="isEmpresa">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.SEPA_Identifier') }}</label>
              <el-form-item prop="SEPAIdentifier">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.SEPAIdentifier.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            <div v-if="!isEmpresa">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.mandate_id') }}</label>
                <el-form-item prop="MandateID">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.MandateID.value"
                    maxlength="60"
                  />
                </el-form-item>
              </div>
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.default_bank_account') }}</label>
                <el-form-item prop="DefaultBankAccount">
                  <base-el-select class="w-full" :options="values" v-model="form.DefaultBankAccount.value" clearable :placeholder="$t('agenda.default_bank_account')" />
                </el-form-item>
              </div>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.bic_swift') }}</label>
              <el-form-item prop="BIC">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.BIC.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
           

          </div>
          </div>  
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    vuexnamespace: {
      type: String,
      default: 'none',
    },
    isEmpresa: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      form: {
        IBANAccountNumber: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
        // Address: { label: i18n.t('address.location'), value: '' },
        // PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        // Town: { label: i18n.t('address.poblacion'), value: '' },
        // Province: { label: i18n.t('address.provincia'), value: '' },
        // CountryCode: { label: i18n.t('address.pais'), value: '' },
        DefaultBankAccount: { label: i18n.t('agenda.default_bank_account'), value: '' },
        MandateID: { label: i18n.t('agenda.mandate_id'), value: '' },
        SEPAIdentifier: { label: i18n.t('agenda.SEPA_Identifier'), value: '' },
        domiciliationFrom: { label: i18n.t('app.from'), value: '' },
        domiciliationTo: { label: i18n.t('app.to'), value: '' },
        BIC: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
        BankAccountAlias: { label: i18n.t('invoices.invoices_issuing.nombre_cuenta'), value: '' },
      },
      loadingData: false,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    formasDePago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    tiposCuenta: function () {
      return this.$store.getters['config/TIPOS_CUENTA']
    },
  },
  mounted: async function () {
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.PaymentType.value = _temp.PaymentType !== undefined && _temp.PaymentType.value !== '' ? _temp.PaymentType.value : ''
        this.form.AccountType.value = _temp.AccountType !== undefined && _temp.AccountType.value !== '' ? _temp.AccountType.value : ''
        this.form.IBANAccountNumber.value = _temp.IBANAccountNumber !== undefined && _temp.IBANAccountNumber.value !== '' ? _temp.IBANAccountNumber.value : ''
        this.form.BankCode.value = _temp.BankCode !== undefined && _temp.BankCode.value !== '' ? _temp.BankCode.value : ''
        this.form.BranchCode.value = _temp.BranchCode !== undefined && _temp.BranchCode.value !== '' ? _temp.BranchCode.value : ''
        // this.form.Address.value = _temp.Address !== undefined && _temp.Address.value !== '' ? _temp.Address.value : ''
        // this.form.PostCode.value = _temp.PostCode !== undefined && _temp.PostCode.value !== '' ? _temp.PostCode.value : ''
        // this.form.Town.value = _temp.Town !== undefined && _temp.Town.value !== '' ? _temp.Town.value : ''
        // this.form.Province.value = _temp.Province !== undefined && _temp.Province.value !== '' ? _temp.Province.value : ''
        // this.form.CountryCode.value = _temp.CountryCode !== undefined && _temp.CountryCode.value !== '' ? _temp.CountryCode.value : ''
        this.form.SEPAIdentifier.value = _temp.SEPAIdentifier !== undefined && _temp.SEPAIdentifier.value !== '' ? _temp.SEPAIdentifier.value : ''
        this.form.MandateID.value = _temp.MandateID !== undefined && _temp.MandateID.value !== '' ? _temp.MandateID.value : ''
        this.form.DefaultBankAccount.value = _temp.DefaultBankAccount !== undefined && _temp.DefaultBankAccount.value !== '' ? _temp.DefaultBankAccount.value : ''
        this.form.BIC.value = _temp.BIC !== undefined && _temp.BIC.value !== '' ? _temp.BIC.value : ''
        this.form.domiciliationFrom.value = _temp.domiciliationFrom !== undefined && _temp.domiciliationFrom.value !== '' ? _temp.domiciliationFrom.value : ''
        this.form.domiciliationTo.value = _temp.domiciliationTo !== undefined && _temp.domiciliationTo.value !== '' ? _temp.domiciliationTo.value : ''
        this.form.BankAccountAlias.value = _temp.BankAccountAlias !== undefined && _temp.BankAccountAlias.value !== '' ? _temp.BankAccountAlias.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        PaymentType: { label: i18n.t('tipos.metadata.pago'), value: '' },
        AccountType: { label: i18n.t('agenda.account_type'), value: '' },
        IBANAccountNumber: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
        BankCode: { label: i18n.t('agenda.bank_code'), value: '' },
        BranchCode: { label: i18n.t('agenda.branch_code'), value: '' },
        Address: { label: i18n.t('address.location'), value: '' },
        PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        Town: { label: i18n.t('address.poblacion'), value: '' },
        Province: { label: i18n.t('address.provincia'), value: '' },
        CountryCode: { label: i18n.t('address.pais'), value: '' },
        BIC: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
        SEPAIdentifier: { label: i18n.t('agenda.SEPA_Identifier'), value: '' },
        domiciliationFrom: { label: i18n.t('app.from'), value: '' },
        domiciliationTo: { label: i18n.t('app.to'), value: '' },
        MandateID: { label: i18n.t('agenda.mandate_id'), value: '' },
        DefaultBankAccount: { label: i18n.t('agenda.default_bank_account'), value: '' },
        BankAccountAlias: { label: i18n.t('invoices.invoices_issuing.nombre_cuenta'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>
